/** Ricerca unica nella testata: segnalazioni, NC, claim e fornitori che il ruolo vede (GET /cerca). */
import { AutoComplete, Input, Tag } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { ANCORA } from "@qa/shared";
import type { RisultatoRicercaDto } from "@qa/shared";
import { api } from "../api/client";

function useRitardato(v: string, ms = 250) {
  const [d, setD] = useState(v);
  useEffect(() => {
    const h = setTimeout(() => setD(v), ms);
    return () => clearTimeout(h);
  }, [v, ms]);
  return d;
}

export function Ricerca() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const qd = useRitardato(q.trim());
  const r = useQuery({ queryKey: ["cerca", qd], queryFn: () => api.get<RisultatoRicercaDto[]>("/cerca", { q: qd }), enabled: qd.length >= 2, staleTime: 30_000 });
  const options = (r.data ?? []).map((x) => ({
    value: `${x.tipo}:${x.id}`,
    link: x.link,
    label: (
      <div style={{ display: "flex", gap: 8, alignItems: "baseline" }}>
        <Tag bordered={false}>{t(`ricerca.${x.tipo}`)}</Tag>
        {x.codice && <span className="mono">{x.codice}</span>}
        <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{x.titolo}</span>
        {x.sottotitolo && <span className="muted small">{x.sottotitolo}</span>}
      </div>
    ),
  }));
  return (
    <AutoComplete
      data-tip={ANCORA.cerca}
      style={{ width: 420, maxWidth: "100%" }}
      options={options}
      value={q}
      onChange={setQ}
      onSelect={(_v: string, o: { link: string }) => {
        setQ("");
        nav(o.link);
      }}
      notFoundContent={qd.length >= 2 && r.isFetched ? t("barra.nessunRisultato") : null}
    >
      <Input prefix={<SearchOutlined />} placeholder={t("barra.cerca")} aria-label={t("barra.cerca")} allowClear />
    </AutoComplete>
  );
}
